<template>
    <tile class="" :paddingAmount="2" :showBorder="quantity > 0">
        <template v-slot:content>
            <div v-if="showImage" class="col xs-5 sm-5 md-3 lg-3 xl-3 vertical-center" :class="stack && 'wide-image'">
                <img class="product-image" :src="imageSource">
            </div>
            <div class="text-left col xs-8 sm-8 flex product-info-container" :class="stack && showImage ? 'md-9' : !showImage ? 'md-8' : 'md-5'">
                <div>
                    <h5 class="product-name text-blue-dark">{{productName}}</h5>
                    <span class="sku-text font-medium text-blue-dark">{{ activeOffer.offerType }}</span>
                    <p class="price">{{ currency.toUpperCase() }}{{ (calculateTotalPrice(salesPrice) * quantity).toFixed(2) }} / {{ defaultTerm }}</p>
                </div>
            </div>
            <div class="col xs-12 sm-12 flex quantity-info-container" :class="stack && showImage ? 'md-9' : !showImage ? 'md-4': 'md-4'">
                <QuantityToggle
                    ref="selectedQuantity"
                    :max="maxPurchasableQuantity"
                    :min="minPurchasableQuantity"
                    :default="startingNumber"
                    @setProductQuantity="setQuantity"
                    @max-exceeded="handleMaxExceeded"
                />
            </div>
            <p v-if="showMaxError" class="max-error">{{ maxError.replace('__maxQuantity__', maxPurchasableQuantity) }}</p>
        </template>
    </tile>
</template>

<script>
import Tile from '../../utils/tile';
import QuantityToggle from '../../utils/quantity-toggle';
import { WebstoreResources } from '../../../mixins/webstore-resources';

export default {
    mixins: [WebstoreResources],

    components: {Tile, QuantityToggle},

    props: {
        imageSource: {
            type: String
        },
        productName: {
            type: String
        },
        salesPrice: {
            type: String
        },
        defaultTerm: {
            type: String
        },
        currency: {
            type: String
        },
        skuText: {
            type:String
        },
        maxPurchasableQuantity: {
            type: Number
        },
        minPurchasableQuantity: {
            type: Number,
            default: 0
        },
        startingNumber: {
            type: Number,
            default: 0
        },
        stack: {
            type: Boolean,
            default: false
        },
        showImage: {
            type: Boolean,
            default: true
        },
        updateTotal: {
            type: Boolean,
            default: false
        },
        maxError: {
            type: String,
            default: ''
        },
    },

    data() {
        return {
            quantity: this.startingNumber,
            showMaxError: false,
        }
    },

    methods: {
        setQuantity(selectedQuantity) {
            this.quantity = selectedQuantity;
            if (this.updateTotal) {
                this.setCablesNeededCountSpecific(selectedQuantity);
            }
        },

        setCablesNeededCountSpecific(quantity) {
            if (this.cablesRequired) {
                return this.$store.commit(
                    `${this.activeProductKey}${this.activeOfferKey}CableSelection/base/setCablesNeededCount`,
                    quantity
                );
            }
        },

        handleMaxExceeded(clear) {
            // Function takes a clear param to unset the error
            this.showMaxError = clear ? false : true
        }
    }


}
</script>

<style scoped>
    .product-name {
        font-weight: bold;
        font-size: 24px;
        color: #2E3438;
        text-transform: none;
        margin-bottom: 6px;
        line-height: 22px;
    }

    .product-image {
        max-width: 140px;
        width: 100%;
    }

    .sku-text {
        font-size: 18px;
        line-height: 24px;
    }

    .flex {
        display: flex;
    }

    .product-info-container {
        align-items: start;
        justify-content: flex-start;
        margin-bottom: 10px;
        padding-right: 20px;
    }

    .quantity-info-container {
        align-items: center;
        justify-content: flex-end;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .wide-image {
        width: 100px !important;
        min-width: 100px;
    }

    .wide-image img {
        width: 100px;
    }

    .flex-wrapper {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .max-error {
        padding-left: 11px;
        color: red;
        font-size: 14px;
    }

    .price {
        font-weight: 400;
        font-size: 20px;
        line-height: 140%;
        margin-top: 13px;
        color: #00263E;
    }

    @media only screen and (max-width: 735px) {
        .product-info-container {
            align-items: center;
            justify-content: center;
            max-width: 100% !important;
            flex-basis: 100% !important;
        }

        .quantity-info-container {
            align-items: center;
            justify-content: center;
        }
    }

</style>
